var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-discover-area': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"top-title",class:{ 'margin-0': _vm.data.image === '' }},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title,"subtitle":_vm.data.subtitle}})],1),_vm._v(" "),(_vm.data.image)?_c('div',{staticClass:"image-full"},[_c('img',{attrs:{"src":`${_vm.resourceUrl(_vm.data.image)}`,"alt":"Image Full Size"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }